import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';

import AdviceSection from '../common/AdviceSection';
import SubMenuTabs from '../common/subMenuTabs/SubMenuTabs';
import SelectEconomic from '../common/select-filters/SelectEconomic';
import DatasetSelectTrend from '../common/select-filters/DatasetSelectTrend';
import MentalRiskCharts from '../common/charts/MentalRiskCharts';
import HealthAwareness from '../common/charts/HealthAwareness';
import TrendDiagram from '../common/charts/TrendDiagram';
import RiskChart from '../common/charts/RiskChart';
import Methodology from '../common/Methodology';
import Related from '../common/Related';

import { overallOpinion } from '../../model/subMenuTabs';

import { setCountry1, setCountry2, setCountry3 } from '../../actions/';

// Countries Exceptions
import { overallOpinionExceptions } from '../../model/countriesExceptions';

const OverallOpinion = (props) => {
	let selected = '';
	for (let i = 0; i < overallOpinion.length; i++)
	{
		if (overallOpinion[i].url == props.indicator)
		{
			selected = overallOpinion[i];
		}
	}
	
	// state from redux
	const { selectCountry, selectCountry2, selectCountry3, selectedByUser, lockedCountry } = useSelector((state) => state.selectCountries);

	const [selectCountry1, setSelectCountry1] = useState(selectedByUser ? lockedCountry : props.country1 != undefined ? props.country1 : selectCountry);
	const [dimension, setDimension] = useState(window.innerWidth > 768 ? 'column' : 'bar');
	const [change, setChange]=useState(true)
	const [title, setTitle] = useState('')
	const [legend, setLegend] = useState(props.literals.L20580)
	const [subMenuTabs, setSubMenuTabs] = useState(overallOpinion)
	const [selectedTab, setSelectedTab] = useState(selected);
	const [currentPath,setCurrentPath]=useState('/working-conditions-preventions/overall-opinion/');
	const [sector, setSector]= useState('sector')
	const [isTrend, setIsTrend]=useState(false);
	const [chart, setChart]=useState('20041');
	const [indicator, setIndicator]=useState('66');
	const [typeChart, setTypeChart]=useState('ewcs');
	const [selectedAnswer, setSelectedAnswer]=useState();
	const [selectedDataset1, setSelectedDataset1]=useState();
	const [selectedDataset2, setSelectedDataset2]=useState();
	const [selectedSortBy, setSelectedSortBy]=useState(false);

	// dispatcher
	const dispatch = useDispatch();

	useEffect(() => {
		updateDimension();
		window.addEventListener('resize',updateDimension);
		return () => window.removeEventListener('resize',updateDimension);
	}, [window.innerWidth])

	useEffect(() => {
		// Update the title of the page
		document.title = props.literals.L22013 +  " - " + props.literals.L22020 + " - " + props.literals.L363;
	},[])

	useEffect(() => {
		const exceptions = overallOpinionExceptions.find((element) => {
			if (selectedByUser) {
				return element.code == lockedCountry
			} else if (!selectedByUser) {
				return element.code == selectCountry
			} else {
				return element.code == props.country1
			}
		})

		if (exceptions) {
			if (selectedByUser) {
				if ( lockedCountry == exceptions.code ) {
					setSelectCountry1('AT');
					if ((selectCountry1 == selectCountry2) || (selectCountry == selectCountry2)) {
						dispatch(setCountry2(''))
					}
					if ((selectCountry1 == selectCountry3) || (selectCountry == selectCountry3)) {
						dispatch(setCountry3(''))
					}
				}
			} else {
				if (( props.country1 != undefined && props.country1 != exceptions.code) || (selectCountry != exceptions.code) ) {
					setSelectCountry1(props.country1)
				} else {
					setSelectCountry1('AT');
					if (selectCountry1 == selectCountry2) {
						dispatch(setCountry2(''))
					}
					if (selectCountry1 == selectCountry3) {
						dispatch(setCountry3(''))
					}
				}
			}
		}
		
	}, [selectedByUser, selectCountry]);

	useEffect(() => {
		if (!selectedByUser && props.country1 != undefined) {
			if (selectCountry != props.country1) {
				dispatch(setCountry1(props.country1))
			}
		}

		if (props.country2 != undefined) {
			dispatch(setCountry2(props.country2))
		}

		if (props.country3 != undefined) {
			dispatch(setCountry3(props.country3))
		}

		if (selectedByUser) {
			if (selectCountry2 == lockedCountry) {
				dispatch(setCountry2(''));
			}
		}
	}, [])

 
	const updateDimension = () =>{
		if (window.innerWidth > 768 ){
			setDimension('column');
			setTitle('How satisfied are you with working conditions in your main paid job?');
		}else{
			setDimension('bar');
			setChange(false);
			setTitle('Job satisfaction');
		}
	}

	const callbackChartLegend = (legend) => {
		setLegend( props.literals['L' + legend] );
	}

	const callbackSelectedSurvey = (callback) => {
		setTypeChart(callback);
	}


	const callbackSelectedTab = (callback) => {
		for (let i = 0; i < subMenuTabs.length; i++)
		{
			if (subMenuTabs[i].url == callback)
			{
				setSelectedTab(subMenuTabs[i]);
				setIsTrend(false);
				if ((callback == "health-at-risk" || callback == "job-satisfaction") && typeChart == "flash")
				{
					setTypeChart("ewcs");
				}
				else if (callback == "health-at-risk" && typeChart == "ewcs" && chart=="20108")
				{
					setChart('20041');
					setIndicator('66');
				}
			}
		}
	}

	const handleSector =(sector)=> {
		if(sector != 'skill'){
			if(chart != '20041'){
				setChart('20041');
				setIndicator('66');
				setTypeChart('ewcs');
			}
		}else{
			setChart('20108');
			setIndicator('390');
			setTypeChart('flash');
		}
	}

	const handleSearch = (selectCountry1) => {
		if (selectedByUser) {
			setSelectCountry1(selectCountry1)
		} else {
			setSelectCountry1(selectCountry1)
			dispatch(setCountry1(selectCountry1))
		}
	}

	const handleSearch2 = (selectCountry2)=>{
		dispatch(setCountry2(selectCountry2));
	}

	const handleSearch3 = (selectCountry3)=>{
		dispatch(setCountry3(selectCountry3));
	}

	const handleTrendButton = () => {
		setIsTrend(!isTrend);
	}

	const handleAnswerChange = (callback) => {
		setSelectedAnswer(callback);
	}

	const handleDefaultDataset = (dataset, selectedIndicator, label) => {
		setSelectedDataset1(dataset);
	}

	const handleDatasetChange1 = (dataset, indicator) => {
		setSelectedDataset1(dataset);
	}

    const handleDatasetChange2 = (dataset, indicator) => {
		setSelectedDataset2(dataset);
	}

	const handleSortButton = () => {
        setSelectedSortBy(!selectedSortBy);
    }

	let currentChart = '';
	let currentDiv = '';

	if(selectedTab.url == 'job-satisfaction'){
		if(!isTrend) {
			currentChart = <MentalRiskCharts
				literals={props.literals}
				tabIndicator={selectedTab.literalTab}
				chartType={selectedTab.chartType}
				selectedIndicator={typeChart}
				colors={['#ffe400','#7b7b7d', '#cbe2e3','#f6a300']}
				type={dimension}
				percentage={true}
				callbackLegend={callbackChartLegend}
				//callbackSelectedSurvey={callbackSelectedSurvey}
				exportingEnabled={true}
				showSelect={true}
				temporalShow={false}
				selectedSortBy={selectedSortBy}
				selectedDataset={selectedDataset1}
			/>
		} else {
			currentChart = <TrendDiagram
				literals={props.literals}
				tabIndicator={selectedTab.literalTab}
				chartType={selectedTab.chartType}
				selectedIndicator={typeChart}
				selectedAnswer={selectedAnswer}
				selectedDataset1={selectedDataset1}
				selectedDataset2={selectedDataset2}
				colors={['#f6a300', '#cbe2e3']}
				type={dimension}
			/>
		}

		currentDiv = <div>
			<DatasetSelectTrend
				literals={props.literals}
				chartType={selectedTab.chartType}
				callbackSelectedSurvey={callbackSelectedSurvey}
				handleAnswerChange={handleAnswerChange}
				handleDefaultDataset = { handleDefaultDataset }
				handleDatasetChange1={(e) => handleDatasetChange1(e)}
				handleDatasetChange2={(e) => handleDatasetChange2(e)}
				showSourceSelect={true}
				showAnswerSelect={isTrend}
				yearOnly = { isTrend ? false : true }
            />
			<div className="line background-main-light"></div>
			<div className="container section--page card--grid xxs-w1 xs-w1 w1 center-text">
				<div className="card--block--chart less-padding">
					<div className={`card--btn-wrapper ${typeChart != 'flash' ? 'with-button' : 'only-switch'}`}>
						<div className="select-filter-chart-wrapper">
							{!isTrend && (<div className="switch--button">
								<input type="checkbox" name="switch-button" id="switch-label" className="switch--button-checkbox" defaultChecked={selectedSortBy} />
								<label htmlFor="switch-label" className="switch--button-label" onClick={handleSortButton}></label>
								<label htmlFor="switch-label" className="text-label" onClick={handleSortButton}>{props.literals["L20341"]}</label>
							</div>)}
						</div>
						{typeChart != 'flash' && (
							<div className='btn-trend-container'>
								<a className="btn-default btn-main-color ng-binding btn-trend" onClick={handleTrendButton}>{!isTrend ? props.literals["L20287"] : props.literals["L20311"]}</a>
							</div>
						)}
					</div>
					<div className="chart--block with-filter" >
						<div className="card--block--chart--wrapper" >
							<div className="chart--wrapper" >
								{currentChart}
							</div>
						</div>
					</div>
				</div>
				<div className="chart-legend">
					{ReactHtmlParser(legend)}
				</div>
			</div>
		</div>
			
	}else if(selectedTab.url == 'health-at-risk'){
		currentDiv = <div>
				<div className="compare--block">
					<SelectEconomic 
						handleSearch={handleSearch} 
						handleSearch2={handleSearch2}
						handleSearch3={handleSearch3}
						charts={[chart]}
						literals={props.literals}
						selectedCountry1={selectCountry1}
						selectedCountry2={selectCountry2}
						selectedCountry3={selectCountry3}
					/>
				</div>
				<div className="line background-main-light"></div>
				<div className="container section--page card--grid xxs-w1 xs-w1 w1 center-text">
					<div className="card--block--chart less-padding">
						<div className="chart--block">
							<RiskChart
								literals={props.literals}
								title={props.literals.L22135}
								colors={['#f6a400','#003399']}
								showDataLabel={true}
								tick={20}
								percentage={true}
								type={dimension}
								selectCountry1={selectCountry1}
								selectCountry2={selectCountry2}
								selectCountry3={selectCountry3}
								chart={chart}
								indicator={indicator}
								typeChart={typeChart}
								sector={[8,9,10,11,12,13]}
								gender={[1,2,3]}
								age={[1,2,5,6,3,4]}
								skill={[1,2,3,4]}
								answer={[1,106]}
								handleSector={handleSector}
								showSelect={true}
								exportingEnabled={true}
								selectedIndicator={'sector'}
							/>
						</div>
					</div>
					<div className="chart-legend">
						{ chart == 20041 ? ReactHtmlParser(props.literals.L20581) : ReactHtmlParser(props.literals.L20582) }
					</div>
				</div>
			</div>
	}else{
		currentDiv = <div className="container section--page card--grid xxs-w1 xs-w1 w1 center-text">
				<div className="card--block--chart" >
					<div className="chart--block">
						<HealthAwareness
							literals={props.literals}
							tabIndicator={selectedTab.literalTab}
							chartType={selectedTab.chartType}
							colors={['#ffe300', '#7b7b7d', '#cbe2e3', '#f6a400']}
							percentage={true}
							noNonEU={true}
							longTitle={true}
						/>
					</div>
				</div>

				<div className="chart-legend">
					{ReactHtmlParser(props.literals.L20367)}
				</div>
			</div>
	}

	let methodologyIndicator = selectedTab.indicator;
	if (selectedTab.url == 'health-at-risk')
	{
		methodologyIndicator = indicator;
	}
	else if (selectedTab.chartType.length == 1)
	{
		methodologyIndicator = selectedTab.chartType[0].chartIndicator;
	}
	else if (selectedTab.chartType.length > 1)
	{
		let datasetChart = selectedTab.chartType.filter(chart=>chart.type==typeChart)[0]
		methodologyIndicator = datasetChart.chartIndicator;
	}

	return(
		<div className="overall-opinion">
			<AdviceSection literals={props.literals} section={["working-conditions-preventions","overall-opinion"]} methodologyData={{section: 'working-conditions-preventions', subsection: 'Working conditions - Overall opinion', indicator: 65}} />
				
			<SubMenuTabs 
				literals={props.literals}
				selectedTab={selectedTab.url}
				callbackSelectedTab={callbackSelectedTab}
				locationPath={currentPath}
				subMenuTabs={subMenuTabs}
				selectCountry1={selectCountry1}
				selectCountry2={selectCountry2}
				selectCountry3={selectCountry3}
				sector={sector}
			/>

			<div className="line background-main-light" />
				
			<div className="">
				{currentDiv}
			</div>

			<Methodology literals={props.literals} section={'Working conditions - Overall opinion'} indicator={methodologyIndicator} />
			<Related literals={props.literals} section={["working-conditions-preventions","overall-opinion",props.indicator]} />
		</div>
		)
	
}

OverallOpinion.displayName = 'OverallOpinion';
export default OverallOpinion;
